import { FC, PropsWithChildren } from 'react'
import { MarketingAlternatives } from '../stateless/marketing/alternative'

// blog wrapper to render content
export const BlogWrapper: FC<
  PropsWithChildren<{ children: any; websiteUrl?: string }>
> = ({ children, websiteUrl }) => {
  // determine banner
  const banner = ['/blog', '/guides', '/blog/authors/jeff-mendez'].some(
    (ppath) => websiteUrl?.endsWith(ppath)
  )

  return (
    <>
      <main id='main-content' data-pagefind-body>
        {children}
        {banner ? <MarketingAlternatives headerType={'h4'} /> : null}
      </main>
    </>
  )
}
